import "./index.scss";
import {
  PortalFooterBrand,
  PortalFooterLink,
  PortalFooterDownload
} from "components/UI/molecules";

export const PortalPrimaryFooter = () => {
  return (
    <div className="portal-primary-footer">
      <PortalFooterBrand />
      <PortalFooterLink />
      <PortalFooterDownload />
    </div>
  );
};
